import React, { useState } from "react";
import LandingLayout from "@/Layouts/LandingLayout";
import { Container } from "@/Components/Container";
import { Inertia } from "@inertiajs/inertia";
import { useTitle } from "@/Utilities/Hooks";
import { LabeledInput } from "@/Components/Form";

export default function ConfirmPassword({ errors }) {
  useTitle("Confirm password");

  let [password, setPassword] = useState("");

  function handleLogin(e) {
    e.preventDefault();

    Inertia.post("/user/confirm-password", { password });
  }

  return (
    <Container size="max-w-2xl bg-white self-center md:dots-topright md:dots-bottomleft overflow-visible relative p-4 md:p-16 md:mt-10">
      <div className="flex flex-col items-start">
        <a href="/">
          <img
            className="mb-8 h-16 w-16 self-start"
            src="/images/logo_dark.png"
            alt="Gidås logo"
          />
        </a>
        <h2 className="mb-2 text-3xl font-bold">Confirm password</h2>
        <p>
          Before you can continue, we need to confirm your password for this
          action.
        </p>
      </div>
      <div className="mt-8">
        <form onSubmit={handleLogin}>
          <LabeledInput
            name="password"
            type="password"
            placeholder="Enter password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            error={errors.password}
          />

          <div className="mt-8 flex justify-end">
            <button className="btn-blue grow-0">Confirm</button>
          </div>
        </form>
      </div>
    </Container>
  );
}

ConfirmPassword.layout = (page) => <LandingLayout>{page}</LandingLayout>;
